import { Component, DoCheck, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Auth } from 'src/app/models/auth';
import { Group, GroupProduct } from 'src/app/models/group';
import { PedidoCadastro } from 'src/app/models/pedido-cadastro';
import { Order, Purchase, PurchaseItens } from 'src/app/models/purchase';
import { ValuesPurchaseRequest, CollaboratorsValue, ValuesProducts } from 'src/app/models/purchase-values';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GroupService } from 'src/app/services/group/group.service';
import { ProductsGroupService } from 'src/app/services/group/products-group.service';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { CartaoPeriodoPadrao } from 'src/app/shared/enums/cartao-periodo-padrao.enum';
import { CategoriaProduto } from 'src/app/shared/enums/categoria-produto.enum';
import { INovoPedido } from 'src/app/shared/interfaces/novo-pedido.interface';
import { ModalFilterColaboradorPeriodoPipe } from 'src/app/shared/pipes/modal-filter-colaborador-periodo.pipe';
import { environment } from 'src/environments/environment';



@Component({
    selector: 'app-nova-compra-periodo',
    templateUrl: './nova-compra-periodo.component.html',
    styleUrls: ['./nova-compra-periodo.component.css']
})
export class NovacompraPeriodoComponent implements OnInit, INovoPedido,  DoCheck {


    constructor(private pedidoDataService: PedidoDataService,
                private router: Router,
                private route: ActivatedRoute,
                private pedidoService: PedidoService,
                private alertService: NewAlertService,
                private modalService: NgbModal,
                private authenticationService: AuthenticationService,
                private productGroupService: ProductsGroupService,
                private grupoService: GroupService,
                private pipeModalFilterColaboradorPipe: ModalFilterColaboradorPeriodoPipe) { }

    public productFlex: Purchase;
    private currentUser: Auth;
    public currentPedidoValue: PedidoCadastro;
    public currentPurchaseValue: Purchase;
    public currentPurchase: Purchase;
    public purchase: Purchase;
    public categoriaProduto: CategoriaProduto;
    public diasUteis = 20;
    public filtroPesquisa: string;
    public sortOrder: boolean;
    public currentPage = 1;
    public showItem = '10';
    public carouselSlide = 0;
    public auxValorSubtotalProduto = [];
    public auxValorTotalProduto = [];
    public taxaProduto = [];
    public valorTotalPedido: number;
    public subtotalPedido: number;
    public taxaPedido: number;
    public gestorId;
    public cedenteId = 0;
    public sumProducts = 0
    public valuesPurchase = new ValuesPurchaseRequest();

    showWorkingDays: boolean = true;

    slideConfig = {arrows: true, slidesToShow: 1, slidesToScroll: 1};

    /*  */

    public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

    public colaboradores = [];
    public colaboradoresList = [];

    //#region Filtro
    public filtroNome: string;
    public filtroCPF: string;
    public filtroMatricula: string;
    public filtroCentroCusto: string;
    public filtroUnidade: string;
    public filtroDepartamento: string;
    public filtroPesquisaSporadic: string;
    //#endregion

    /* Filtros */
    public filtroCentroCustoDropDownList = [];
    public filtroCentroCustoSelectedItems = [];
    public filtroUnidadeDropDownList = [];
    public filtroUnidadeSelectedItems = [];
    public filtroDepartamentoDropDownList = [];
    public filtroDepartamentoSelectedItems = [];

    public nameCtrl: FormControl = new FormControl();
    public cpfCtrl: FormControl = new FormControl();
    public registerCtrl: FormControl = new FormControl();

    public grupo: Group;

    public productOfGroup: GroupProduct[];
    public productOfGroupFlex: GroupProduct;

    public dropDownSettings: IDropdownSettings = {};

    ngOnInit() {

        this.currentUser = this.authenticationService.currentUserValue;
        this.currentPurchaseValue = this.pedidoDataService.currentPurchaseValue;
        if(this.currentPurchaseValue.group != null){
            this.grupo = new Group();
            this.grupo.id = this.currentPurchaseValue.group.groupId.toString();
            this.grupo.guidID = this.currentPurchaseValue.group.groupGuid;
        }else{
            this.grupo = this.grupoService.getGrupo();
        }
        //this.grupo = this.grupoService.getGrupo();

        this.load();

        this.purchase = new Purchase(0,'');
        this.purchase.purchaseItens = [];
        this.purchase.managerGuid = this.currentUser.token.userReferenceId;
        this.purchase.purchaseItens.forEach( e => {
            e.order.orderItens = [];
        });

        this.valuesPurchase.purchaseId = this.currentPurchaseValue.purchaseId;
        this.valuesPurchase.products = [];
        
    }
    ngDoCheck() {
        this.getCarouselSlideVisible();

    }

    getProductsOfGroup() {
        this.productGroupService.getGroupsByGroup(this.grupo.guidID, this.currentPurchaseValue.assignorId).subscribe(res => {

            if (res.status === 1) {
                this.productOfGroupFlex = res.result.find(e => e.productCategory == 2)
                this.productOfGroup = [];
                this.productOfGroup = res.result;
                this.applyDiasUteis();
                
                this.productOfGroup.filter(x=>x.productCategory != 2).forEach((item: any) => {
                    this.sumProducts += item.value;
                });
            }

        });
    }

    public load() {
        if(this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === CategoriaProduto.Incentivo
        || item.order.productCategory === CategoriaProduto.IncentivoPlus)){
            this.showWorkingDays = false;
        }
        if(!this.currentPurchaseValue.flexIndividual && this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === 2)){
            this.productFlex = new Purchase(0,'');
            this.productFlex.purchaseItens = [];
            this.productFlex.managerGuid = this.currentUser.token.userReferenceId;
            this.productFlex.purchaseItens.forEach( e => {
                e.order.orderItens = [];
            });
            this.clone();
        }
        this.currentPurchaseValue.purchaseItens[0].order.orderItens.forEach(element => {
            if(element.document != undefined || element.document != null){
                element.document = element.document.toString();
                const tam = environment.TOTAL_CARACTERE_CPF - element.document.length;
                let str = element.document.toString();
                for (let i = 0; i < tam; i++) {
                                    str = '0' + str;
                                }
                element.document = str;
            }
        });
        this.colaboradores = this.currentPurchaseValue.purchaseItens[0].order.orderItens;
        this.colaboradoresList = this.currentPurchaseValue.purchaseItens[0].order.orderItens;
        if (this.currentPurchaseValue) {
            this.diasUteis = 20; // this.currentPurchaseValue.diasUteis;
            if(this.productFlex){
                this.getProductsOfGroup();
            }else{
                this.applyDiasUteis();
            }
        }
    }

    clone() {
        if(this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === 2)){
            let aux = this.currentPurchaseValue.purchaseItens.findIndex(item => item.order.productCategory === 2)
            this.productFlex.purchaseItens[0] = new PurchaseItens();
            this.productFlex.purchaseItens[0].order = new Order();
            this.productFlex.purchaseItens[0].productId = this.currentPurchaseValue.purchaseItens[aux].productId;
            this.productFlex.purchaseItens[0].order.assignorContractId = this.currentPurchaseValue.purchaseItens[aux].order.assignorContractId;
            this.productFlex.purchaseItens[0].order.productDescription = this.currentPurchaseValue.purchaseItens[aux].order.productDescription;
            this.productFlex.purchaseItens[0].order.productGuid = this.currentPurchaseValue.purchaseItens[aux].order.productGuid;
            this.productFlex.purchaseItens[0].order.managerId = this.currentPurchaseValue.purchaseItens[aux].order.managerId;
            this.productFlex.purchaseItens[0].order.totalFeePercent = this.currentPurchaseValue.purchaseItens[aux].order.totalFeePercent;
            this.productFlex.purchaseItens[0].order.orderItens = this.currentPurchaseValue.purchaseItens[aux].order.orderItens;
            this.productFlex.purchaseItens[0].order.isPercent = this.currentPurchaseValue.purchaseItens[aux].order.isPercent;
        }
    }

      slickInit(e) {
        console.log('slick initialized');
      }

      breakpoint(e) {
        console.log('breakpoint');
      }

      afterChange(e) {
        console.log('afterChange');
      }

      beforeChange(e) {
        console.log('beforeChange');
      }

    applyDiasUteis() {
        if (!this.productFlex) {
            for (const purchaseItem of this.currentPurchaseValue.purchaseItens) {
                
                let valuesProducts = new ValuesProducts();
                for (const orderItem of purchaseItem.order.orderItens) {
                    
                    let collaboratorsValue = new CollaboratorsValue();
            
                    if (orderItem.referenceValue != orderItem.providedValue) {
                        collaboratorsValue.collaboratorId = orderItem.collaboratorId;
                        collaboratorsValue.value = orderItem.referenceValue;
                        valuesProducts.collaboratorValues.push(collaboratorsValue);
                    }  

                    if (Number(orderItem.regularityId) === CartaoPeriodoPadrao.Diario) {
                        let auxValor = 0;
                        auxValor =  orderItem.referenceValue * Number(this.diasUteis);
                        orderItem.providedValue = (Math.round(auxValor * 1000) / 1000);

                    } else if (Number(orderItem.regularityId) === CartaoPeriodoPadrao.Mensal) {
                        let auxValor = 0;
                        auxValor = orderItem.referenceValue;
                        orderItem.providedValue = auxValor;

                        orderItem.providedValue = (Math.round(orderItem.referenceValue * 1000) / 1000);
                    } else if (Number(orderItem.regularityId) === CartaoPeriodoPadrao.Unico) {
                        let auxValor = 0;
                        auxValor = orderItem.referenceValue;
                        orderItem.providedValue = auxValor;

                        orderItem.providedValue = (Math.round(orderItem.referenceValue * 1000) / 1000);
                    }
                }
                    
                valuesProducts.productId = purchaseItem.productId;
                this.valuesPurchase.products.push(valuesProducts)
            }

        } else {
            for (const purchaseItem of this.currentPurchaseValue.purchaseItens) {
                for (const orderItem of purchaseItem.order.orderItens) {
                    if (Number(orderItem.regularityId) === CartaoPeriodoPadrao.Diario) {
                        let auxValor = 0;
                        auxValor =  orderItem.referenceValue * Number(this.diasUteis);
                        orderItem.providedValue = (Math.round(auxValor * 1000) / 1000);

                    } else if (Number(orderItem.regularityId) === CartaoPeriodoPadrao.Mensal) {
                        let auxValor = 0;
                        auxValor = orderItem.referenceValue;
                        orderItem.providedValue = auxValor;
                        orderItem.providedValue = (Math.round(orderItem.referenceValue * 1000) / 1000);

                    } else if (Number(orderItem.regularityId) === CartaoPeriodoPadrao.Unico) {
                        let auxValor = 0;
                        auxValor = orderItem.referenceValue;
                        orderItem.providedValue = auxValor;
                        orderItem.providedValue = (Math.round(orderItem.referenceValue * 1000) / 1000);
                    }
                }
            }
        }
        this.updateValorColaborador();
        this.updateValorPedido();
    }

    updateValorColaborador() {
        if(!this.productFlex){
            for (const s of this.currentPurchaseValue.purchaseItens) {
                s.order.orderValue = 0;
                for (let i = 0; i < s.order.orderItens.length; i++) {
                    s.order.orderValue += s.order.orderItens[i].providedValue;
                    s.order.orderValue = (Math.round(s.order.orderValue * 1000) / 1000)
                }
            }
        }else{
            for (const s of this.currentPurchaseValue.purchaseItens) {
                s.order.orderValue = 0;
                for (let i = 0; i < s.order.orderItens.length; i++) {
                    s.order.orderValue += s.order.orderItens[i].providedValue;
                    s.order.orderValue= (Math.round(s.order.orderValue * 1000) / 1000)
                }
            }
        }
    }

    updateValorPedido() {
        const subtotalProduto = [];
        const totalProduto = [];
        this.currentPurchaseValue.purchaseItens.forEach(objCompraItem => {
            subtotalProduto.push(0);
        });

        let total = 0;
        let subtotal = 0;
        let taxa = 0;
        let i = 0;
        if(!this.productFlex){
            for (const s of this.currentPurchaseValue.purchaseItens) {
                subtotalProduto[i] = s.order.orderValue + subtotalProduto[i];
                i++;
            }
            this.auxValorSubtotalProduto = subtotalProduto;
            for (let i = 0; i < this.auxValorSubtotalProduto.length; i++) {
                if(this.currentPurchaseValue.purchaseItens[i].order.isPercent){
                    this.auxValorTotalProduto[i] = (this.auxValorSubtotalProduto[i] * this.currentPurchaseValue.purchaseItens[i].order.totalFeePercent / 100);
                    this.taxaProduto[i] = (this.auxValorSubtotalProduto[i] * this.currentPurchaseValue.purchaseItens[i].order.totalFeePercent / 100);
                    taxa += this.auxValorTotalProduto[i];
                }
                else{
                    this.auxValorTotalProduto[i] = (this.auxValorSubtotalProduto[i] + this.currentPurchaseValue.purchaseItens[i].order.totalFeePercent * this.currentPurchaseValue.purchaseItens[i].order.orderItens.length);
                    this.taxaProduto[i] = (this.auxValorSubtotalProduto[i] + this.currentPurchaseValue.purchaseItens[i].order.totalFeePercent * this.currentPurchaseValue.purchaseItens[i].order.orderItens.length);
                    taxa += this.currentPurchaseValue.purchaseItens[i].order.totalFeePercent * this.currentPurchaseValue.purchaseItens[i].order.orderItens.length;
                }
                subtotal += this.auxValorSubtotalProduto[i];
            }
            for (let i = 0; i < this.auxValorTotalProduto.length; i++) {
                if(this.currentPurchaseValue.purchaseItens[i].order.isPercent){
                    total += this.auxValorSubtotalProduto[i] + this.auxValorTotalProduto[i];
                    this.auxValorTotalProduto[i] += this.auxValorSubtotalProduto[i];
                }
                else{
                    total += this.auxValorTotalProduto[i];
                    //this.auxValorTotalProduto[i] += this.auxValorSubtotalProduto[i];
                }

            }
            this.taxaPedido = taxa;
            this.subtotalPedido = subtotal;
            this.valorTotalPedido = total;
        }else{
            for (const s of this.currentPurchaseValue.purchaseItens) {
                subtotalProduto[i] = s.order.orderValue + subtotalProduto[i];
                i++;
            }
            this.auxValorSubtotalProduto = subtotalProduto;
            for (let i = 0; i < this.auxValorSubtotalProduto.length; i++) {
                this.auxValorTotalProduto[i] = 0;
                if(this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === 2).order.isPercent){
                    this.auxValorTotalProduto[i] = (this.auxValorSubtotalProduto[i] * this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === 2).order.totalFeePercent / 100);
                    this.taxaProduto[i] = (this.auxValorSubtotalProduto[i] * this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === 2).order.totalFeePercent / 100);
                    taxa += this.auxValorTotalProduto[i];
                }
                else {
                    if(this.currentPurchaseValue.purchaseItens[i].order.orderValue != 0){
                        if(this.currentPurchaseValue.purchaseItens[i].order.productCategory == 2) {
                            this.auxValorTotalProduto[i] = (this.auxValorSubtotalProduto[i] + this.currentPurchaseValue.purchaseItens[i].order.totalFeePercent * this.currentPurchaseValue.purchaseItens[i].order.orderItens.length);
                            this.taxaProduto[i] = (this.auxValorSubtotalProduto[i] + this.currentPurchaseValue.purchaseItens[i].order.totalFeePercent * this.currentPurchaseValue.purchaseItens[i].order.orderItens.length);
                            taxa += this.currentPurchaseValue.purchaseItens[i].order.totalFeePercent * this.currentPurchaseValue.purchaseItens[i].order.orderItens.length;
                        } else {
                            this.auxValorTotalProduto[i] = this.auxValorSubtotalProduto[i];
                            this.taxaProduto[i] = this.auxValorSubtotalProduto[i];
                        }
                    }
                    else{
                        if(this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === 2).order.isPercent){
                            this.auxValorTotalProduto[i] = (this.auxValorSubtotalProduto[i] * this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === 2).order.totalFeePercent / 100);
                            this.taxaProduto[i] = (this.auxValorSubtotalProduto[i] * this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === 2).order.totalFeePercent / 100);
                            taxa += this.auxValorTotalProduto[i];
                        }
                    }
                }
                subtotal += this.auxValorSubtotalProduto[i];
            }
            for (let i = 0; i < this.auxValorTotalProduto.length; i++) {
                if(this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === 2).order.isPercent){
                    total += this.auxValorSubtotalProduto[i] + this.auxValorTotalProduto[i];
                    this.auxValorTotalProduto[i] += this.auxValorSubtotalProduto[i];
                }
                else{
                    total += this.auxValorTotalProduto[i];
                    //this.auxValorTotalProduto[i] += this.auxValorSubtotalProduto[i];
                }
            }
            this.taxaPedido = taxa;
            this.subtotalPedido = subtotal;
            this.valorTotalPedido = total;
        }
    }

    updateCartaoPeriodoPadrao() {
        for (const purchaseItens of this.currentPurchaseValue.purchaseItens) {
            if (this.currentPurchaseValue.purchaseItens.length > 0) {
                for (const orderItens of purchaseItens.order.orderItens) {
                    if (Number(orderItens.regularityId) === CartaoPeriodoPadrao.Diario) {
                        orderItens.regularityDescription = 'Diário';
                    } else if (Number(orderItens.regularityId) === CartaoPeriodoPadrao.Mensal) {
                        orderItens.regularityDescription = 'Mensal';
                    } else if (Number(orderItens.regularityId) === CartaoPeriodoPadrao.Unico) {
                        orderItens.regularityDescription = 'Único';
                    }
                }
            }
        }
    }

    orderBy(collumnName: string, sortOrder: boolean) {
        this.currentPedidoValue.pedidoItens.sort(
            (a, b) => {
                const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
                const aVal = (a[collumnName] === null ? dftl : a[collumnName]).toString();
                const bVal = (b[collumnName] === null ? dftl : b[collumnName]).toString();
                let result = aVal.localeCompare(bVal, undefined, { numeric: true });

                if (sortOrder) {
                    result = bVal.localeCompare(aVal, undefined, { numeric: true });
                }

                return result;
            }
        );
    }

    savePedido() {

        this.currentPurchaseValue.purchaseItens[0].order.orderItens.forEach(element => {

            element.document = parseInt(element.document);
        });
        this.purchase = JSON.parse(JSON.stringify(this.currentPurchaseValue));

        this.purchase.purchaseValue =  Math.round(this.valorTotalPedido * 1000) / 1000;
        this.purchase.purchaseFee = Math.round(this.taxaPedido * 1000) / 1000;
        if(this.productFlex){
            this.productOfGroup.forEach(obj => {
                this.purchase.purchaseItens.forEach(compraItem => {
                    compraItem.order.orderItens.forEach(orderItem => {
                        if(obj.productID === compraItem.productId){
                            orderItem.providedValue = obj.standardPeriodCard == 2 ? (Math.round(obj.value * 1000) / 1000) * Number(this.diasUteis) : (Math.round(obj.value * 1000) / 1000);
                            orderItem.referenceValue = obj.value;
                            compraItem.order.orderValue = orderItem.providedValue * compraItem.order.orderItens.length
                        }
                    });
                });
            });
        } else {
            let i = 0;
            this.purchase.purchaseItens.forEach(compraItem => {
                compraItem.order.orderItens.forEach(cards => {
                    cards.referenceValue = Math.round(cards.referenceValue * 1000) / 1000;
                    cards.providedValue = Math.round(cards.providedValue * 1000) / 1000;
                });
                compraItem.order.orderValue += this.taxaProduto[i];
                compraItem.order.totalFee = Math.round(this.taxaProduto[i] * 1000) / 1000;
                i++;
            });
        }
        this.pedidoService.createPurchase(this.currentUser.token.assignorGuid, this.purchase).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    for (let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++) {

                        this.purchase.purchaseId = response.result.purchaseId
                        this.purchase.purchaseItens[i].order.orderId = response.result.purchaseItens[i].order.orderId;
                        this.purchase.purchaseItens[i].order.orderDescription = response.result.purchaseItens[i].order.orderDescription;
                        this.purchase.purchaseItens[i].purchaseItemId = response.result.purchaseItens[i].purchaseItemId;
                        this.purchase.purchaseItens[i].purchaseId = response.result.purchaseId;
                    }
                    this.pedidoService.updatePurchase(this.currentUser.token.assignorGuid, this.purchase).subscribe(
                        res => {
                            this.purchase.purchaseUseBalance = false;
                            this.purchase.purchaseValue = this.valorTotalPedido;
                            if (res.status === ApiError.Sucesso) {
                                this.alertService.success('Recarga salva');
                            } else {
                                this.alertService.success('Erro ao salvar a recarga');
                            }

                    });

                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error(error);
            }
        );
    }
    displayProduto() {
        const idName = 'slide' + this.carouselSlide;

        const slides = document.getElementsByClassName('slide');
        if (this.carouselSlide < slides.length - 1) {
            this.carouselSlide++;
        } else {
            this.carouselSlide = 0;
        }

        for (let i = 0; i < slides.length; i++) {
            slides[i].setAttribute('style', 'display:none');
        }
        const id = document.getElementById(idName + '-item');
        id.setAttribute('style', 'display:block');
    }

    getCarouselSlideVisible() {
        let title;
        for (let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++) {
            const titlename = 'title' + i;
            const cardClass = 'card' + i;
            const teste = document.getElementById(titlename);
            const cardDiv = document.getElementsByClassName(cardClass);
            if (teste != null && cardDiv != null) {

                for (let i = 0; i < cardDiv.length; i++) {
                    cardDiv[i].setAttribute('style', 'display: none');

                }

                if (teste.getAttribute('aria-hidden') == 'false') {


                    for (let i = 0; i < cardDiv.length; i++) {
                        cardDiv[i].setAttribute('style', 'display: table-cell');

                    }
                    const esse = teste.firstChild.firstChild.firstChild.textContent;

                }
            }


        }

    }

    next() {
        if (this.currentPurchaseValue.purchaseState != 8) {
            this.currentPurchaseValue.purchaseItens[0].order.orderItens.forEach(element => {
                if (element.document != null)
                    element.document = element.document.toString();
            });
            this.currentPurchase = this.pedidoDataService.currentPurchaseValue;
            let isValid = true;

            this.currentPurchase.purchaseItens.forEach(obj => {
                if ((obj.order.orderValue <= 0 || obj.order.orderItens.find(x => x.providedValue == 0)) && !this.productFlex) {
                    isValid = false;
                }
            });
            if (!isValid) {
                this.alertService.error('Por favor, insira um valor válido para cada favorecido.');
                if (this.currentPurchase.purchaseItens.length > 1
                    && this.currentPurchase.purchaseItens.find(x => x.order.orderValue == 0)
                    && !this.productFlex)
                    this.alertService.error('Verifique o valor dos demais incentivos.');
                else if (this.currentPurchase.purchaseItens.find(x => x.order.orderValue == 0)) {
                    this.alertService.error('Valor a ser disponibilizado é inválido.');
                }

            } else {
                this.currentPurchase.purchaseValue = Math.round(this.valorTotalPedido * 1000) / 1000;
                this.currentPurchase.purchaseFee = Math.round(this.taxaPedido * 1000) / 1000;
                // if(this.productFlex){
                //     this.productOfGroup.forEach(obj => {
                //         this.currentPurchaseValue.purchaseItens.forEach(compraItem => {
                //             compraItem.order.orderItens.forEach(orderItem => {
                //                 if(obj.productID === compraItem.productId){
                //                     orderItem.providedValue = obj.standardPeriodCard == 2 ? (Math.round(obj.value * 1000) / 1000) * Number(this.diasUteis) : (Math.round(obj.value * 1000) / 1000);
                //                     orderItem.referenceValue = obj.value;
                //                 }
                //             });
                //         });
                //     });
                // }

                let i = 0;
                this.currentPurchaseValue.purchaseItens.forEach(compraItem => {
                    compraItem.order.orderItens.forEach(cards => {
                        cards.referenceValue = Math.round(cards.referenceValue * 1000) / 1000;
                        cards.providedValue = Math.round(cards.providedValue * 1000) / 1000;
                    });
                    if (this.productFlex && this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === 2).order.isPercent) {
                        compraItem.order.orderValue += this.taxaProduto[i];
                        compraItem.order.totalFee = Math.round((this.taxaProduto[i]) * 1000) / 1000;
                    } else if (!this.productFlex && this.currentPurchaseValue.purchaseItens[i].order.isPercent) {
                        compraItem.order.orderValue += this.taxaProduto[i];
                        compraItem.order.totalFee = Math.round((this.taxaProduto[i]) * 1000) / 1000;
                    } else {
                        compraItem.order.orderValue = this.taxaProduto[i];
                        if (compraItem.order.orderValue != 0)
                            compraItem.order.totalFee = Math.round((compraItem.order.totalFeePercent * compraItem.order.orderItens.length) * 1000) / 1000;
                        else
                            compraItem.order.totalFee = 0;
                    }
                    i++;
                });

                this.pedidoService.updatePurchase(this.currentUser.token.assignorGuid, this.currentPurchase).subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            if (this.currentPurchaseValue.purchaseUseBalance === null)
                                this.currentPurchase.purchaseUseBalance = false;
                            this.currentPurchase.purchaseValue = Math.round(this.valorTotalPedido * 1000) / 1000;
                            this.pedidoDataService.setCurrentPurchaseValue(this.currentPurchaseValue);

                            this.pedidoDataService.setCurrentPurchaseValue(this.currentPurchase);
                            this.router.navigate(['confirmarrecarga'], { relativeTo: this.route.parent });
                        } else {
                            this.alertService.error(response.message);
                        }
                    }
                );
            }
        } else {  
            console.log(this.valuesPurchase)
            this.pedidoService.UpdatePurchaseValues(this.valuesPurchase, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.pedidoService.getPurchaseById(this.currentPurchaseValue.purchaseId, this.currentUser.token.assignorGuid, false).subscribe(
                            response => {
                                if (response.status === ApiError.Sucesso || (response.status === ApiError.Insucesso && response.result)) {
                                    response.result.managerGuid = this.currentUser.token.userReferenceId
                                    response.result.purchaseItens.forEach(pi => {
                                        pi.ehEditavel = true;
                                        pi.order.orderItens.forEach(oi => {
                                            oi.referenceValue = oi.providedValue;
                                        })
                                    });
                                    this.pedidoDataService.setCurrentPurchaseValue(response.result);
                                    this.router.navigate(['confirmarrecarga'], { relativeTo: this.route.parent });

                                    if (response.status === ApiError.Insucesso)
                                        this.alertService.error(response.message);

                                } else {
                                    this.router.navigate(['list'], { relativeTo: this.route.parent });
                                    this.alertService.error(response.message);
                                }
                            },
                            error => { this.alertService.error(error); }
                        );

                    } else {
                        this.alertService.error(response.message);
                    }
                }
            );
        }
    }

    previous() {
        if (this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === 2)) {
            this.router.navigate(['selecionargrupocolaborador'], { relativeTo: this.route.parent });
        } else {
            this.router.navigate(['selecionarcolaborador'], { relativeTo: this.route.parent });
        }
    }

    toArray(orderItens: object) {
        return Object.keys(orderItens).map(key => orderItens[key]);
    }
    /* Filtros */

    public loadFiltroDropDown() {
        this.dropDownSettings = {
            singleSelection: false,
            idField: 'ITEM_ID',
            textField: 'ITEM_TEXT',
            selectAllText: 'Selecionar Tudo',
            unSelectAllText: 'Desmarcar Tudo',
            searchPlaceholderText: 'Buscar',
            allowSearchFilter: true,
            itemsShowLimit: 3
        };
    }

    onItemSelectFiltroCentroCusto(item: any) { }
    onSelectAllFiltroCentroCusto(items: any) { }
    onItemDeSelectFiltroCentroCusto(items: any) { }

    onItemSelectFiltroUnidade(item: any) { }
    onSelectAllFiltroUnidade(items: any) { }
    onItemDeSelectFiltroUnidade(items: any) { }

    onItemSelectFiltroDepartamento(item: any) { }
    onSelectAllFiltroDepartamento(items: any) { }
    onItemDeSelectFiltroDepartamento(items: any) { }

    applyFilter(nome: string, cpf: string, matricula: string) {
        this.filtroNome = this.nameCtrl.value;
        this.filtroCPF = this.cpfCtrl.value;
        this.filtroMatricula = this.registerCtrl.value;
        this.colaboradores = this.pipeModalFilterColaboradorPipe
            .transform(this.colaboradoresList, this.filtroPesquisa, '', this.filtroNome, this.filtroCPF,
                this.filtroMatricula, '');



    }


    selectAll(value: boolean) {
        const colaboradores = this.pipeModalFilterColaboradorPipe
            .transform(this.colaboradoresList, this.filtroPesquisa, '', this.filtroNome, this.filtroCPF,
                this.filtroMatricula,  '');
        colaboradores.forEach(obj => {
            if (this.colaboradoresList.find(x => x.colaboradorId === obj.colaboradorId)) {
                obj.selected = value;
            }
        });

    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }
    removerFilter() {
        this.filtroNome = '';
        this.filtroCPF = '';
        this.filtroMatricula = '';
        this.colaboradores = this.pipeModalFilterColaboradorPipe
            .transform(this.colaboradoresList, this.filtroPesquisa, '', this.filtroNome, this.filtroCPF,
                this.filtroMatricula, '');
    }

    showModal(content: any) {
        this.modalService.open(content, { centered: true, size: 'xl' });
    }

    totalProvidedValue(value: any){
        return this.sumProducts + value;
    }
}
